import { RouteAuthorizationData } from './models/authorization/route-authorization-data.interface';
import { AccessType } from './models/authorization';
import { PERMISSION_KEYS } from './constants/permissions.constants';

/**
 * Centralized route authorization configuration
 * Defines permission requirements for protected routes
 */
export const AuthPageConfig = {
  // Dashboard
  Dashboard: {
    title: "Dashboard",
    data: {
      requiredPermissionKey: PERMISSION_KEYS.DASHBOARD_MAIN,
      requiredAccess: AccessType.Read
    } as RouteAuthorizationData
  },

  // Applications
  Applications: {
    title: "Application Portfolio",
    data: {
      requiredPermissionKey: PERMISSION_KEYS.APPLICATIONS_PORTFOLIO,
      requiredAccess: AccessType.Read
    } as RouteAuthorizationData
  },

  // Assessment
  Assessment: {
    title: "Assessment",
    data: {
      requiredPermissionKey: PERMISSION_KEYS.ASSESSMENT_MAIN,
      requiredAccess: AccessType.Read
    } as RouteAuthorizationData
  },

  AssessmentCreate: {
    title: "Assessment - Create",
    data: {
      requiredPermissionKey: PERMISSION_KEYS.ASSESSMENT_MAIN,
      requiredAccess: AccessType.Write
    } as RouteAuthorizationData
  },

  // Admin
  Admin: {
    title: "Admin",
    data: {
      requiredPermissionKey: PERMISSION_KEYS.ADMIN_MAIN,
      requiredAccess: AccessType.Read
    } as RouteAuthorizationData
  },

  // Admin (configuration)
  AdminSizingCriteria: {
    title: "Admin - Sizing Criteria",
    data: {
      requiredPermissionKey: PERMISSION_KEYS.ADMIN_SIZING_CRITERIA,
      requiredAccess: AccessType.Read
    } as RouteAuthorizationData
  },

  AdminAIConfig: {
    title: "Admin - AI Config - Code Assessment",
    data: {
      requiredPermissionKey: PERMISSION_KEYS.ADMIN_AI_CONFIG,
      requiredAccess: AccessType.Read
    } as RouteAuthorizationData
  },

  AdminAiCmdbAssessment: {
    title: "Admin - AI Config - CMDB Assessment",
    data: {
      requiredPermissionKey: PERMISSION_KEYS.ADMIN_AI_CONFIG,
      requiredAccess: AccessType.Read
    } as RouteAuthorizationData
  },

  AdminRolesPrivileges: {
    title: "Admin - Roles & Privileges",
    data: {
      requiredPermissionKey: PERMISSION_KEYS.ADMIN_ROLES_PRIVILEGES,
      requiredAccess: AccessType.Read
    } as RouteAuthorizationData
  },

  AdminCmdbSync: {
    title: "Admin - CMDB Sync",
    data: {
      requiredPermissionKey: PERMISSION_KEYS.ADMIN_CMDB_SYNC,
      requiredAccess: AccessType.Read
    } as RouteAuthorizationData
  },

  AdminPodsList: {
    title: "Admin - POD's List",
    data: {
      requiredPermissionKey: PERMISSION_KEYS.ADMIN_PODS_LIST,
      requiredAccess: AccessType.Read
    } as RouteAuthorizationData
  },

  AdminApplication: {
    title: "Admin - Application",
    data: {
      requiredPermissionKey: PERMISSION_KEYS.ADMIN_PODS_LIST,
      requiredAccess: AccessType.Read
    } as RouteAuthorizationData
  },

  AdminPlatformMaster: {
    title: "Admin - Platform Master",
    data: {
      requiredPermissionKey: PERMISSION_KEYS.ADMIN_PLATFORM_MASTER,
      requiredAccess: AccessType.Write
    } as RouteAuthorizationData
  },

  // Help
  Help: {
    title: "Help",
    data: {
      requiredPermissionKey: PERMISSION_KEYS.HELP_MAIN,
      requiredAccess: AccessType.Read
    } as RouteAuthorizationData
  },

  // Reports
  Reports: {
    title: "Reports",
    data: {
      requiredPermissionKey: PERMISSION_KEYS.REPORTS_MAIN,
      requiredAccess: AccessType.Read
    } as RouteAuthorizationData
  }
};
